/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable no-undef */
import React, { useState } from 'react';

import Button from '@cashew/button';
import ConfirmModal from '@cashew/confirm-modal';
import { api } from '@cashew/utils';

export default ({
  orderDetails,
  showConfirmModal,
  setShowConfirmModal,
  token,
  language,
  history,
  t,
  portalName,
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
}: any) => {
  type Status = 'warning' | 'error' | 'info' | 'success' | 'none';
  const [showResult, setShowResult] = useState(false);
  const [resultStatus, setResultStatus] = useState<Status>('none');
  const cancelSubscription = () => {
    api
					.patch({
						endpoint: `orders/${orderDetails.id}/status`,
						params: {
							orderStatusEnum: 'CANCELLED',
						},
						headers: {
							Authorization: token,
						},
					})
					.then(() => {
						setShowResult(true);
						setResultStatus('success');
					})
					.catch((resp) => {
						api.errorHandler({
							resp,
							history,
							callback: () => {
								setShowResult(true);
								setResultStatus('warning');
							},
						});
					});
  };
  return (
    <ConfirmModal
      isVisible={showConfirmModal}
      onClose={() => {
        setShowConfirmModal(false);
      }}
      showCloseButton={false}
      confirmTitle="Confirm cancellation?"
      confirmDescription={`Are you sure you want to cancel your <b>${orderDetails?.store?.storeName}</b> subscription?<br/>Your renewal and billing will be turned off immediately.`}
      confirmButtons={
        <div>
          <Button
            extraClass="secondary"
            onClick={() => {
              setShowConfirmModal(false);
            }}
          >
            No
          </Button>
          <Button
            onClick={() => {
              cancelSubscription();
            }}
          >
            Cancel Subscription
          </Button>
        </div>
      }
      resultTitle={t(`title.${resultStatus}`)}
      resultDescription={t(`resultDescription.${resultStatus}`, {
        storeName: `${orderDetails.store?.storeName}`,
      })}
      resultButtons={
        <div>
          <Button
            onClick={() => {
              history.push(`/${language}/subscriptions`);
            }}
          >
            Ok
          </Button>
        </div>
      }
      showResult={showResult}
      resultStatus={resultStatus}
    />
  );
};
